import { gql } from '@apollo/client'

export const GET_RUN = gql`
  query GetRun($clientId: ID!, $runId: ID!) {
    run(clientId: $clientId, runId: $runId) {
      id clientId status startedAt completedAt resultsCount
      token_usage: tokenUsage { input_tokens: inputTokens output_tokens: outputTokens total_tokens: totalTokens }
      estimated_cost_usd: estimatedCostUsd
      engine results events
      errorMessage
      graphNodes
      completedNodes
      active_node: activeNode
      progressPct
      formattedOutput
      nodeProgress {
        name
        status
        completedAt
        data
      }
    }
  }
`

export const GET_RUNS_STATUS = gql`
  query GetRunsStatus($runIds: [ID!]!) {
    runsStatus(runIds: $runIds) {
      id clientId status startedAt completedAt resultsCount estimatedCostUsd engine
    }
  }
`

export const START_CAMPAIGN = gql`
  mutation StartCampaign($clientId: ID!, $selectedContentTypes: [String!], $engine: String, $buyerJourneyStages: [String!]) {
    startCampaign(clientId: $clientId, selectedContentTypes: $selectedContentTypes, engine: $engine, buyerJourneyStages: $buyerJourneyStages) {
      runId lgThreadId lgRunId status engine
    }
  }
`

export const GET_RUNS = gql`
  query GetRuns($clientId: ID!) {
    client(id: $clientId) {
      runs {
        id clientId startedAt completedAt status resultsCount trigger
        tokenUsage { inputTokens outputTokens totalTokens }
        estimatedCostUsd engine selectedContentTypes
        errorMessage
      }
    }
  }
`

export const STOP_RUN = gql`
  mutation StopRun($clientId: ID!, $runId: ID!) {
    stopRun(clientId: $clientId, runId: $runId)
  }
`
